/**
 * 计算表格列的合并规则
 * @param tableBody 表格数据体
 * @param columnIndex 需要合并的列索引
 * @returns 合并规则数组，每个元素包含起始行索引和跨度
 */
export function calculateMergeRules(
  tableBody: any[][],
  columnIndex: number
): Array<{ startRow: number; rowSpan: number }> {
  if (!tableBody || tableBody.length <= 1) {
    return [];
  }

  const mergeRules = [];
  let currentValue = null;
  let startRowIndex = 0;
  let rowSpan = 1;

  // 遍历表格行，从第一个数据行开始（跳过标题行）
  for (let i = 0; i < tableBody.length; i++) {
    const row = tableBody[i];

    // 获取当前单元格的值
    const cellValue = row[columnIndex]?.text || row[columnIndex];

    if (i === 0) {
      // 第一个数据行，初始化当前值
      currentValue = cellValue;
      startRowIndex = i;
    } else if (cellValue === currentValue) {
      // 与前一个单元格值相同，增加跨度计数
      rowSpan++;
    } else {
      // 值不同，记录之前的合并规则
      if (rowSpan > 1) {
        mergeRules.push({ startRow: startRowIndex, rowSpan: rowSpan });
      }

      // 重置计数器和当前值
      currentValue = cellValue;
      startRowIndex = i;
      rowSpan = 1;
    }
  }

  // 处理最后一组相同值
  if (rowSpan > 1) {
    mergeRules.push({ startRow: startRowIndex, rowSpan: rowSpan });
  }

  return mergeRules;
}
